import React, { useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { FormattedMessage, useIntl } from 'react-intl';
import NegotiationService from '../../../services/NegotiationService';
import ConfirmModal from '../../../_shared/components/ConfirmModal';
import convertToCurrency from '../../../_shared/utils/convertToCurrency';
import { acceptOffer, declineOffer } from './NegotiationModalEvents';
import ReducerConstants from '../../../_shared/constants/reducers';
import {
  ButtonPrimary,
  LinkPrimary,
  Row,
  SecondBidderFooter,
  SecondBidderOfferLabel,
  SecondBidderOfferStatusWrapper,
  StyledSecondBidderForm
} from './Styles';
import useAnalytics from '../../../_shared/hooks/useAnalytics';

const SecondBidderForm = ({
  latestOffer,
  tradeDetails,
  close,
  setOnAccept,
  onNegotiationEnded
}) => {
  const track = useAnalytics();
  const intl = useIntl();
  const finalPriceStr = convertToCurrency(latestOffer?.price);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [confirmModalLogic, setConfirmModalLogic] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const user = useSelector(
    state => state[ReducerConstants.AUTH]?.user,
    shallowEqual
  );

  const negotiationService = NegotiationService.get();

  const negotiationModalEventVariables = {
    setConfirmModalLogic,
    negotiationService,
    close,
    latestOffer,
    tradeDetails,
    setIsConfirmModalOpen,
    msgId: 'modal.negotiation.decline.description.secondBidder',
    intl,
    setOnAccept,
    setIsLoading,
    isSellContext: false,
    user,
    isSecondBidder: true,
    onNegotiationEnded,
    track
  };

  return (
    <StyledSecondBidderForm>
      <Row>
        <SecondBidderOfferStatusWrapper>
          <div id="offer" htmlFor="acceptOffer">
            <SecondBidderOfferLabel>
              <FormattedMessage id="vdp.pending.buyer.label.finalAskingPrice" />
            </SecondBidderOfferLabel>
            <span>{finalPriceStr}</span>
          </div>
        </SecondBidderOfferStatusWrapper>
      </Row>
      <SecondBidderFooter>
        <LinkPrimary
          onClick={() => declineOffer(negotiationModalEventVariables)}
          id="acceptOffer"
        >
          <FormattedMessage id="modal.negotiation.decline" />
        </LinkPrimary>
        <ButtonPrimary
          onClick={() => acceptOffer(negotiationModalEventVariables)}
        >
          <FormattedMessage
            id="modal.negotiation.accept.secondBidder"
            values={{ offer: finalPriceStr }}
          />
        </ButtonPrimary>
      </SecondBidderFooter>
      <ConfirmModal
        modalLogic={confirmModalLogic}
        isOpen={isConfirmModalOpen}
        isLoading={isLoading}
        loadingMsg={<FormattedMessage id="modal.confirmation.loading" />}
      />
    </StyledSecondBidderForm>
  );
};

export default SecondBidderForm;
